import Vue from "vue"
import DatetimePicker from "vuetify-datetime-picker"
import "vuetify-datetime-picker/src/stylus/main.styl"

Vue.use(DatetimePicker)
